module.exports = __webpack_public_path__ + "static/media/flow-mode.6ba6582a.png";